import React, { memo } from "react";

import { formatUnitPrice } from "services/api/pricing/consts";

import { SubscriptionMeteredListProps } from "../../types";

/**
 * Mjereni troškovi — što se naplaćuje po komadu, bez obzira na pretplatu.
 *
 * Naš trošak (`nabava.*`) ovdje ne postoji: čarobnjak ga niti dohvaća niti prima.
 */
const SubscriptionMeteredList: React.FC<SubscriptionMeteredListProps> = (props) => {
  const { meteredKeys, breakdowns, isLoading } = props;

  return (
    <div>
      <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold mb-3">
        Mjereni troškovi
      </h3>

      <div className="border border-slate-200 divide-y divide-slate-100">
        {meteredKeys.map((key) => {
          const breakdown = breakdowns[key.code];

          return (
            <div
              key={key.code}
              className="flex items-center justify-between px-4 py-2.5"
            >
              <span className="text-sm text-slate-700">{key.name}</span>

              {isLoading && (
                <span className="h-4 w-16 bg-slate-100 animate-pulse" />
              )}

              {!isLoading && !breakdown && (
                <span className="text-sm text-slate-400">Nije razriješeno</span>
              )}

              {!isLoading && breakdown && (
                <span className="text-sm font-medium text-slate-900">
                  {formatUnitPrice.format(breakdown.effective)}
                  {breakdown.effective !== breakdown.standard && (
                    <span className="ml-2 text-xs text-slate-400 line-through">
                      {formatUnitPrice.format(breakdown.standard)}
                    </span>
                  )}
                </span>
              )}
            </div>
          );
        })}

        {meteredKeys.length === 0 && (
          <p className="px-4 py-3 text-sm text-slate-400">
            Cjenik nema mjerenih stavki.
          </p>
        )}
      </div>
    </div>
  );
};

export default memo(SubscriptionMeteredList);
